import NoData from 'common/NoData';
import PageContainer from 'common/PageContainer';
import PageLoader from 'common/PageLoader';
import { BookingsContext } from 'pages/Bookings/context';
import { ClassAttributes, HTMLAttributes, useContext } from 'react';
import {
  AutoSizer,
  Column,
  InfiniteLoader,
  RowMouseEventHandlerParams,
  Table,
} from 'react-virtualized';
import { Col, Row } from 'reactstrap';
import 'react-virtualized/styles.css';
import { PersonCircle } from 'react-bootstrap-icons';
import moment from 'moment';
import { useNavigate } from 'react-router';


const rowRenderer = (props: {
  className: any;
  columns: any;
  index?: number;
  isScrolling?: boolean;
  key?: string;
  onRowClick?: (id: any,userId: any) => void;
  onRowDoubleClick?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  onRowMouseOver?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  onRowMouseOut?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  onRowRightClick?: ((params: RowMouseEventHandlerParams) => void) | undefined;
  rowData: any;
  style: any;
}) => {
  const { columns, className, rowData, style, onRowClick } = props;
  if (!rowData) {
    console.warn('Row data is missing:', props);
    return null;
  }
  console.log('props.rowdata.....', props.rowData);
  const { id, startTime } = rowData;

  console.log(
    'user billing address..',
    rowData.billingAddress.address,
    rowData.billingAddress.city,
  );

  const name = rowData?.user?.firstName
    ? `${rowData.user.firstName
        .charAt(0)
        .toUpperCase()}${rowData.user.firstName.substring(1)} ${
        rowData.user?.lastName
          ? `${rowData.user.lastName
              .charAt(0)
              .toUpperCase()}${rowData.user.lastName.substring(1)}`
          : ''
      }`
    : '---';

  const phone = rowData.user ? `${rowData.user.phone || ''}` : '---';

  const address = rowData.billingAddress
    ? `${rowData.billingAddress.address || ''}, ${
        rowData.billingAddress.city || ''
      }, ${rowData.billingAddress.zip || ''}`
    : '-';

  const chefName = rowData.chef
    ? `${rowData.chef.firstName || ''} ${rowData.chef.lastName || ''}`
    : '';
  console.log(
    ',,,,,,,,,,,,,,,,,chef...',
    rowData.chef.firstName,
    rowData.chef.lastName,
  );

  return (
    <div
      className={className}
      style={style}
      onClick={() => onRowClick?.(id,rowData.user?.id)}
      key={`customer-row-${id}`}
    >
      {columns.map(
        (col: {
          props: JSX.IntrinsicAttributes &
            ClassAttributes<HTMLDivElement> &
            HTMLAttributes<HTMLDivElement>;
        }) => {
          const keyName: any = col.props['aria-describedby'];

          let value = rowData[keyName];

          if (typeof value === 'object' && value !== null) {
            value = JSON.stringify(value);
          }
          if (keyName === 'Name') {
            return (
              <div
                {...col.props}
                title={name}
                key={`${col.props['aria-describedby']}-cell-${id}`}
              >
                <PersonCircle className="me-2" size={20} />

                <span>{name && name.trim()?.length ? name : '--'}</span>
              </div>
            );
          }
          if (keyName === 'phone') {
            return (
              <div {...col.props} title={phone} key={`${keyName}-cell-${id}`}>
                {phone}
              </div>
            );
          }

          if (keyName === 'billingAddress') {
            return (
              <div {...col.props} title={address} key={`${keyName}-cell-${id}`}>
                {address}
              </div>
            );
          }

          if (keyName === 'meals') {
            // value = meals.join(", ");
            value = rowData?.meals?.length
              ? rowData.meals
                  .map(
                    (meal: any) =>
                      meal.charAt(0).toUpperCase() + meal.substring(1),
                  )
                  .join(', ')
              : 'N/A';
          }

          if (keyName === 'startTime') {
            value =
              moment(
                startTime.replace('.', ':').toUpperCase(),
                'h:mm A',
              ).format('hh:mm A') || 'N/A';
          }

          if (keyName === 'startDate') {
            value = moment(rowData.startDate).format('DD/MM/YYYY') || 'N/A';
          }

          if (keyName === 'chefName') {
            return (
              <div
                {...col.props}
                title={chefName}
                key={`${col.props['aria-describedby']}-cell-${id}`}
              >
                <span>
                  {chefName && chefName.trim()?.length ? (
                    <>
                      {' '}
                      <PersonCircle className="me-2" size={20} /> $
                      {chefName}{' '}
                    </>
                  ) : (
                    'Unassigned'
                  )}
                </span>
              </div>
            );
          }

          return (
            <div
              {...col.props}
              title={value || '-'}
              key={`${col.props['aria-describedby']}-cell-${id}`}
            >
              {value || '-'}
            </div>
          );
        },
      )}
    </div>
  );
};

export const UpcomingTable = () => {
  const bookingsContext = useContext(BookingsContext);

  const navigate = useNavigate();

  if (!bookingsContext || !bookingsContext.bookingData) {
    return <div>Context not available</div>;
  }

  const {
    bookingData: { isLoading, status, error, data: bookings },
    loadMore,
  } = bookingsContext;

  if (isLoading) return <PageLoader />;
  if (error) return <span>Something went wrong</span>;
  if (status === 200 && !bookings?.length)
    return <NoData customMessage="No result found" />;

  const isRowLoaded = ({ index }: { index: number }) => !!bookings[index];
const handleRowClick = (customerId: string,userId: string) => {
  navigate(`/app/customers/${userId}/details`, {
    state: {
      heading: 'Booking Details',
      iconClass: 'bi bi-chevron-left',
    },
  });
    console.log('Row clicked with customerId:', customerId);
    console.log('Row clicked with userId:', userId);
    // console.log('Row clicked with bookings:', bookings);
};


  return (
    <PageContainer>
      <h6 className="mb-3">Upcoming Bookings</h6>
      <Row>
        <Col>
          <InfiniteLoader
            isRowLoaded={isRowLoaded}
            loadMoreRows={loadMore}
            rowCount={bookings.length}
          >
            {({ onRowsRendered, registerChild }) => (
              <AutoSizer disableHeight>
                {({ width }) => (
                  <Table
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    rowClassName="table-row"
                    headerHeight={32}
                    width={width}
                    height={450}
                    rowHeight={50}
                    rowCount={bookings.length}
                    rowGetter={({ index }) => bookings[index]}
                    // onRowClick={handleRowClick}
                    rowRenderer={(props) =>
                      rowRenderer({
                        ...props,
                        onRowClick: handleRowClick,
                      })
                    }
                  >
                    <Column
                      label="Name"
                      dataKey="name"
                      width={width * 0.15}
                      id="Name"
                    />
                    <Column
                      label="Phone"
                      dataKey="phone"
                      width={width * 0.15}
                      id="phone"
                    />
                    <Column
                      label="Meals"
                      dataKey="meals"
                      width={width * 0.15}
                      id="meals"
                    />
                    <Column
                      label="Person"
                      dataKey="headCount"
                      width={width * 0.1}
                      id="headCount"
                    />
                    <Column
                      label="Address"
                      dataKey="billingAddress"
                      width={width * 0.25}
                      id="billingAddress"
                    />
                    <Column
                      label="Date"
                      dataKey="startDate"
                      width={width * 0.1}
                      id="startDate"
                    />
                    <Column
                      label="Time"
                      dataKey="startTime"
                      width={width * 0.1}
                      id="startTime"
                    />
                    <Column
                      label="Chef"
                      dataKey="chefName"
                      width={width * 0.1}
                      id="chefName"
                    />
                  </Table>
                )}
              </AutoSizer>
            )}
          </InfiniteLoader>
        </Col>
      </Row>
    </PageContainer>
  );
};
